import { createConfig, configureChains } from 'use-wagmi';
import { alchemyProvider } from 'use-wagmi/providers/alchemy';
import { CoinbaseWalletConnector } from 'use-wagmi/connectors/coinbaseWallet';
import { MetaMaskConnector } from 'use-wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'use-wagmi/connectors/walletConnect';
import { publicProvider } from 'use-wagmi/providers/public'
import { mainnet, polygon, dogechain } from 'viem/chains';
import { isMobileAgent } from './helper';
import { coinbaseWallet, recommendedWallet } from './config';
const apiKey = process.env.VUE_APP_ALCHEMY_API_KEY;

const { chains, webSocketPublicClient, publicClient } = configureChains([mainnet, polygon, dogechain], [
  alchemyProvider({ apiKey }),
  publicProvider(),
]);

const connectors = [];
let explorerExcludedWalletIds = []
let explorerRecommendedWalletIds = recommendedWallet;
if(isMobileAgent()) {
  explorerExcludedWalletIds = [coinbaseWallet]; // remove coinbase
  explorerRecommendedWalletIds = explorerRecommendedWalletIds.filter(val => val !== coinbaseWallet)
} else {
  explorerExcludedWalletIds = [];
  explorerRecommendedWalletIds.push(coinbaseWallet); // add coinbase
}
connectors.push(
  new WalletConnectConnector({
    chains,
    options: {
      showQrModal: true,
      projectId: process.env.VUE_APP_WALLET_CONNECT_PROJECT_ID,
      metadata: {
        url: process.env.VUE_APP_URL,
        description: "Rocketfuel Payments",
        name: "Rocketfuel.inc",
        icons: ['https://qa-merchant.rocketdemo.net/logo_full_dark.svg'],
      },
      qrModalOptions: {
        enableExplorer: true,
        explorerExcludedWalletIds,
        explorerRecommendedWalletIds,
        themeMode: "light",
        themeVariables: {
          "--wcm-background-color": '#5e72e4',
          "--wcm-overlay-background-color": '#333333',
        }
      },
      qrcode: true,
    },

  })
);

if(!isMobileAgent()) {
  connectors.push(  new CoinbaseWalletConnector({
    chains,
    options: {
      appName: 'Rocketfuel',
    }
  }));
  connectors.push(new MetaMaskConnector({ chains }));
}
// setting up connectors of wallet payments
const WagmiClient = createConfig({
  autoConnect: true,
  storage: localStorage,
  logger: true,
  connectors: connectors,
  publicClient,
  webSocketPublicClient
})
export default WagmiClient;
